module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Red Open.abe695f5.png";